// Create: /pages/AdminDashboardPage.jsx
import React from 'react';
import AdminCreateFee from '../components/Admin/AdminCreateFee';

const AdminCreateFeePage = () => {
  return <AdminCreateFee />;
};

export default AdminCreateFeePage;